<template>
  <div>
    <div
      v-for="({ label, input, display = 'block', showOn, tooltip },
      i) in questions"
      :key="label + i"
    >
      <div
        v-if="!showOn || (showOn && showOn === $root.countries.selected)"
        :class="
          `q-and-a q-and-a--${display} p-6 ${i % 2 === 0 ? 'bg-lblue' : ''}`
        "
      >
        <div class="question">
          <div class="u-h2 font-normal">
            {{ label }}
            <Tooltip v-if="tooltip && tooltip.heading" v-bind="tooltip" />
          </div>
        </div>
        <div class="answer">
          <vue-numeric
            v-if="input.type === 'currency'"
            :currency="$root.currency"
            v-model="$root[input.name]"
            class="text-center font-semibold text-24px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue';
export default {
  components: { Tooltip },
  props: ['questions'],
  data: () => ({}),
  computed: {},
};
</script>

<style></style>
